import './orchestrators/onFolderClickedInMoveToControlActionOrchestrator';
export { getMoveToPropertiesForContextMenu, getMoveToPropertiesForCommandBar, } from './components/getMoveToMenuProperties';
//# sourceMappingURL=index.js.map